import { AxiosInstance, AxiosResponse } from 'axios'
import { inject } from 'tsyringe'
import { httpToken } from '~/constants/dependency-injection/tokens'

/**
 * Should be redacted from public.
 */
import { containerScoped } from '~/decorators/dependency-container'
import { LogsResponse } from '~/models/log'
import { LogFormatter } from '~/services/admin/classified/LogFormatter'
import { invalidBodyError } from '../../errors'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { ClassifiedsOverview } from '~/models/user/types'

@containerScoped()
export default class AdminClassifiedService {
  constructor(
    @inject(httpToken) private http: AxiosInstance,
    @inject(LogFormatter) private logFormatter: LogFormatter,
    @inject(RequestBuilder) private requestBuilder: RequestBuilder
  ) {}

  // TODO: maybe type the response later
  async getPerpetratorInfo(classifiedId: number): Promise<any> {
    const response: AxiosResponse = await this.http.get(
      `/api/admin/classifieds/${classifiedId}/perpetrator/`
    )
    const { data: body } = response
    if (!body) {
      throw invalidBodyError(body)
    }
    return body
  }

  async getLogs(classifiedId: number): Promise<LogsResponse> {
    const response: AxiosResponse = await this.http.get(
      `/api/admin/classifieds/${classifiedId}/logs/`
    )
    const { data: body } = response
    if (!(body && body.data)) {
      throw invalidBodyError(body)
    }
    return this.formatLogs(body.data)
  }

  private formatLogs(r: any): LogsResponse {
    // handling a backend edge case
    if (Array.isArray(r.logs) && r.logs.length === 0) {
      return { logs: [], actions: r.actions }
    }
    return {
      logs:
        r.logs && r.logs.rows.map((r: any) => this.logFormatter.formatLog(r)),
      actions: r.actions
    }
  }

  async deleteOldClassifieds(userId: number | string): Promise<any> {
    return await this.requestBuilder
      .request(
        'DELETE',
        `/api/admin/users/${userId}/delete-hidden-classifieds/`
      )
      .validate(body => body)
      .map(body => body)
      .send()
  }

  getClassifiedsOverview(
    userId: string
  ): Promise<{ classifiedsOverview: ClassifiedsOverview }> {
    return this.requestBuilder
      .request('get', `/api/admin/users/${userId}/classifieds-overview/`)
      .send()
  }
}
